import DisonaLogoSrc from 'themes/disonaTheme/icons/menu/logo.svg';
import routes from 'common/constants/routing.constants';
import React from 'react';
import * as S from './styled';

export const Logo = (props) => {
  const { history } = props;
  return (
    <S.Logo onClick={() => history.push(routes.trading.path)} {...props}>
      <img src={DisonaLogoSrc} alt="logo" />
    </S.Logo>
  );
};
